module.exports = require("/Users/bryansng/Documents/repos/trackster-gatsby-and-app/trackster-gatsby/gatsby/gatsby-browser.tsx");